<body class="horizontal-layout horizontal-menu 2-columns">
    <app-header></app-header>

    <div class="app-content content">
        <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>
</body>